<template>
  <div v-if="display.visible" class="emoji-picker">
    <div class="emoji-picker__search">
      <input type="text" v-model="search" v-focus />
      <span class="emoji-close" @click="display.visible = false"><i class="fas fa-times"></i></span>
    </div>
    <div>
      <div v-for="(emojiGroup, category) in emojis" :key="category">
        <h5>{{ category }}</h5>
        <div class="emojis">
          <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import emojis from './emojis'
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
const escapeRegExp = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
export default {
  name: 'emoji-widget',
  props: {
    emojiTable: {
      type: Object,
      required: false,
      default() {
        return emojis
      }
    }
  },
  data() {
    return {
      search: '',
      display: {
        x: 0,
        y: 0,
        visible: false
      }
    }
  },
  mounted() {
    document.addEventListener('keyup', this.escape)
  },
  computed: {
    emojis() {
      if (this.search) {
        const obj = {}
        for (const category in this.emojiTable) {
          obj[category] = {}
          for (const emoji in this.emojiTable[category]) {
            if (new RegExp(`.*${escapeRegExp(this.search)}.*`).test(emoji)) {
              obj[category][emoji] = this.emojiTable[category][emoji]
            }
          }
          if (Object.keys(obj[category]).length === 0) {
            delete obj[category]
          }
        }
        return obj
      }
      return this.emojiTable
    }
  },
  methods: {
    insert(emoji) {
      this.$emit('emoji', emoji)
    },
    toggle() {
      this.display.visible = !this.display.visible
    },
    hide() {
      this.display.visible = false
    },
    escape(e) {
      if (this.display.visible === true && e.keyCode === 27) {
        this.display.visible = false
      }
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  },
  beforeUnmount() {
    document.removeEventListener('keyup', this.escape)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/elements/emoji/emoji-widget.vue